import {create} from 'zustand';

const useCoordinatesStore = create((set) => ({
  coordinates: {
    lat: 50.7753,
    lng: 6.0839
  },
  updateCoordinates: (payload) =>
    set((state) => {
      const prev = state.coordinates;
      const newData = typeof payload === "function" ? payload(prev) : payload;
      const filtered = {};
      if (newData.lat !== undefined) filtered.lat = Number(newData.lat);
      if (newData.lng !== undefined) filtered.lng = Number(newData.lng);
      return { coordinates: { ...prev, ...filtered } };
    }),
}));

export default useCoordinatesStore;
